import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/**
 * Ô chỉ số: nhãn nhỏ + số lớn (Fraunces) + đơn vị, gạch màu dọc bên trái.
 * Thấp hơn hẳn thẻ thống kê mặc định của template nên nhiều ô xếp dọc trên
 * điện thoại vẫn không đẩy nội dung chính xuống quá sâu.
 *
 * `mau` là mã màu đã đọc sẵn từ theme ở nơi gọi (vd. `palette.info.main`) —
 * thẻ không tự chọn màu để mỗi trang tự quyết ý nghĩa của từng chỉ số.
 */
function TheChiSo({ nhan, giaTri, donVi, icon, mau }) {
  return (
    <Card sx={{ height: "100%", overflow: "hidden" }}>
      <MDBox display="flex" height="100%">
        <MDBox sx={{ width: 4, flexShrink: 0, backgroundColor: mau }} />
        <MDBox width="100%" px={2.5} py={2}>
          <MDBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <MDTypography variant="overline" color="text" lineHeight={1}>
              {nhan}
            </MDTypography>
            {icon && <Icon sx={{ color: mau, fontSize: "1.25rem" }}>{icon}</Icon>}
          </MDBox>
          <MDTypography
            variant="h4"
            mt={0.75}
            lineHeight={1.15}
            sx={{
              wordBreak: "break-word",
              fontSize: { xs: "1.75rem", md: "1.5rem", lg: "1.75rem" },
            }}
          >
            {giaTri}
          </MDTypography>
          {donVi && (
            <MDTypography variant="caption" color="text" display="block" mt={0.25}>
              {donVi}
            </MDTypography>
          )}
        </MDBox>
      </MDBox>
    </Card>
  );
}

TheChiSo.propTypes = {
  nhan: PropTypes.string.isRequired,
  giaTri: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  donVi: PropTypes.string,
  icon: PropTypes.string,
  mau: PropTypes.string.isRequired,
};

export default TheChiSo;
